namespace $.$$ {

	export class $shm_hitalama_taskmanager_column extends $.$shm_hitalama_taskmanager_column {

		count_label() {
			return String( this.tasks().length )
		}

		task_rows() {
			return this.tasks().map( task => this.Task( task.id ) )
		}

		column_body() {
			return this.raw_opened() ? [ this.Raw() ] : [ this.Tasks() ]
		}

		head_tools() {
			if( this.raw_opened() ) return [ this.Raw_cancel(), this.Raw_save() ]
			return [
				... this.status() === 'todo' ? [ this.Add() ] : [],
				this.Raw_open(),
			]
		}

		task_to_raw( task: $shm_hitalama_taskmanager_task ) {
			return `#${ task.priority }\n${ task.title.trim() }`.trim()
		}

		tasks_to_raw() {
			return this.tasks().map( task => this.task_to_raw( task ) ).join( '\n\n' )
		}

		raw_parse( raw: string ) {
			const status = this.status() as $shm_hitalama_taskmanager_status
			const exists = this.tasks()
			const used = new Set< string >()
			const tasks = [] as $shm_hitalama_taskmanager_task[]
			let priority = 'normal' as $shm_hitalama_taskmanager_task_priority
			let lines = [] as string[]
			let started = false

			const push = ()=> {
				const title = lines.join( '\n' ).trim()
				lines = []
				if( !started ) return

				const prev = exists.find( task => task.title.trim() === title && !used.has( task.id ) )
				if( prev ) {
					used.add( prev.id )
					tasks.push({ ... prev, title, status, priority })
					return
				}

				const created_at = Date.now()
				tasks.push({
					id: `${ created_at }-${ tasks.length }-${ Math.random().toString( 36 ).slice( 2 ) }`,
					title,
					status,
					priority,
					created_at,
					status_changed_at: created_at,
				})
			}

			for( const line of raw.split( /\r?\n/ ) ) {
				const match = line.trim().match( /^#(low|normal|high)(?:\s+(.*))?$/ )
				if( match ) {
					push()
					priority = match[1] as $shm_hitalama_taskmanager_task_priority
					if( match[2] ) lines.push( match[2] )
					started = true
					continue
				}
				lines.push( line )
			}

			push()
			return tasks
		}

		@ $mol_action
		raw_open( next?: Event ) {
			if( next === undefined ) return null
			this.raw( this.tasks_to_raw() )
			this.raw_opened( true )
			return next
		}

		@ $mol_action
		raw_cancel( next?: Event ) {
			if( next === undefined ) return null
			this.raw_opened( false )
			return next
		}

		@ $mol_action
		raw_save( next?: Event ) {
			if( next === undefined ) return null
			this.tasks( this.raw_parse( this.raw() ) )
			this.raw_opened( false )
			return next
		}

	}

}
